import React from "react";
import Text, { CopyProps, TextVariant } from "@/components/ui/text";
import { cn } from "@/utils/utils";

export type BadgeProps = BadgeBaseProps & CopyProps;

interface BadgeBaseProps {
  text?: string;
  icon?: JSX.Element;
  className?: string;
  textVariant?: TextVariant;
  textClassName?: string;
  selected?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const Badge: React.FC<BadgeProps> = ({
  text,
  icon,
  className,
  textVariant,
  textClassName = "",
  selected,
  onClick,
  children,
  style,
  ...copyProps
}) => (
  <div
    className={cn(
      "px-2 py-[6px] gap-[6px] rounded-lg border-[0.5px] border-badge-default flex items-center justify-center bg-badges-default w-fit transition-all duration-200 ease-in-out",
      selected && "bg-badges-selected border-border-badge-selected",
      className
    )}
    onClick={onClick}
    style={style}
  >
    {icon && icon}
    {children ? (
      children
    ) : (
      <Text
        variant={textVariant || "body"}
        className={textClassName}
        {...copyProps}
      >
        {text}
      </Text>
    )}
  </div>
);

export default Badge;
